// extracted by mini-css-extract-plugin
export var dismissOverlay = "_g2-b";
export var interactivePassthrough = "_g2-3";
export var modal = "_g2-d";
export var modalBackdrop = "_g2-c";
export var modalBody = "_g2-j";
export var modalDescription = "_g2-m";
export var modalEnter = "_g2-e";
export var modalFooter = "_g2-n";
export var modalHeaderText = "_g2-h";
export var modalIconCircle = "_g2-i";
export var modalIconHeader = "_g2-g";
export var modalImage = "_g2-f";
export var modalSectionLabel = "_g2-k";
export var modalTitle = "_g2-l";
export var pulse = "_g2-1";
export var pulseBorder = "_g2-2";
export var spotlight = "_g2-0";
export var tooltip = "_g2-4";
export var tooltipButtons = "_g2-9";
export var tooltipDescription = "_g2-6";
export var tooltipFooter = "_g2-7";
export var tooltipInteractivePill = "_g2-a";
export var tooltipStepIndicator = "_g2-8";
export var tooltipTitle = "_g2-5";